import { parseBranchClientLogo } from '@/lib/branch-client-logo'
import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'
import { dynamicsApi } from './client'
import { QUERY_KEYS } from './query-keys'

const imageResponseSchema = z.object({ value: z.string().min(1) })

export { parseBranchClientLogo } from '@/lib/branch-client-logo'

export function useBranchClientLogoQuery(
  branchId: string | null | undefined,
  proposalLogoBase64?: string | null
) {
  const query = useQuery({
    queryKey: QUERY_KEYS.branchClientLogo(branchId),
    enabled: !!branchId && proposalLogoBase64 === undefined,
    queryFn: async () => {
      try {
        const response = await dynamicsApi.get(
          `/dsy_branchs(${branchId})/dsy_logo?size=full`
        )
        const parsed = imageResponseSchema.safeParse(response.data)
        return parsed.success ? parseBranchClientLogo(parsed.data.value) : null
      } catch {
        return null
      }
    },
    staleTime: 60_000,
  })

  return {
    ...query,
    data: proposalLogoBase64 === undefined ? query.data : parseBranchClientLogo(proposalLogoBase64),
  }
}
